<template>
  <div>
    <v-app-bar
      dense
      flat
      height="50"
    >
      <v-row align="center">
        <v-col
          xs="12"
          sm="3"
          class="d-none d-sm-flex"
        >
          <v-text-field
            v-model.trim="engine_version"
            append-icon="mdi-magnify"
            placeholder="Search version"
            single-line
            clearable
            outlined
            hide-details
            dense
            @input="onVersionChange"
          />
        </v-col>
        <v-spacer />
        <v-col
          xs="12"
          sm="6"
          align="end"
          class="d-none d-flex justify-end align-center"
        >
          <v-btn
            id="app_refresh"
            color="primary"
            :loading="loader"
            class="mr-1 elevation-0"
            @click.native="reload()"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-btn
            id="new_app"
            class="mr-1 elevation-0"
            color="success"
            @click="newRelease()"
          >
            <v-icon>mdi-plus</v-icon> Release
          </v-btn>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-card
      flat
      tile
    >
      <v-card-text>
        <v-row>
          <v-col
            xs="12"
            class="pa-0"
          >
            <v-data-table
              :headers="headers"
              :items="appReleases"
              :items-per-page="limit"
              :loading="loader"
              hide-default-footer
              mobile-breakpoint="0"
            >
              <template v-slot:item.created_at="{ item }">
                {{ formatDate(item.created_at) }}
              </template>
              <template v-slot:[`item.tags`]="{ item }">
                <v-chip
                  v-if="item.approved && !item.deprecated"
                  label
                  tile
                  color="green"
                  dark
                  class="ma-1"
                >
                  <v-icon
                    small
                    left
                  >
                    mdi-check-decagram
                  </v-icon>
                  Approved
                </v-chip>
                <v-chip
                  v-if="item.stable && !item.deprecated"
                  label
                  color="primary"
                  dark
                  class="ma-1"
                >
                  <v-icon
                    small
                    left
                  >
                    mdi-check-circle-outline
                  </v-icon>
                  Stable
                </v-chip>
                <v-chip
                  v-if="item.deprecated"
                  label
                  color="orange"
                  dark
                  class="ma-1"
                >
                  <v-icon
                    small
                    left
                    color="white"
                  >
                    mdi-alert
                  </v-icon>
                  Deprecated
                </v-chip>
              </template>
              <template v-slot:[`item.apps`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <a
                      target="_blank"
                      :href="getAppUrl(item.engine_version)"
                      v-on="on"
                    >
                      Show Apps
                    </a>
                  </template>
                  <span>{{ getAppUrl(item.engine_version) }}</span>
                </v-tooltip>
                <copy-button :text="getAppUrl(item.engine_version)" />
              </template>
              <template v-slot:[`item.options`]="{ item }">
                <releases-options
                  :item="item"
                  @open="open"
                  @openView="openView"
                  @refresh="reload"
                />
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-show="totalPage > 1">
        <v-row>
          <v-col>
            <v-pagination
              v-model="page"
              :length="totalPage"
              @input="getAppReleases()"
            />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <new-app-release
      ref="newAppReleaseDialog"
      :edit-release="editRelease"
      @refresh="reload"
    />
    <ReleaseViewDialog
      ref="releaseDialog"
      v-model="RVDialog"
      :release="selectedRelease"
    />
  </div>
</template>

<script>
import { failure, pagination } from "@/mixins/common";
import NewAppRelease from "./NewAppRelease";
import ReleasesOptions from "./ReleasesOptions.vue";
import CopyButton from "@/components/utils/CopyButton.vue";
import ReleaseViewDialog from "./ReleaseViewDiloag.vue";

export default {
  name: "AppReleases",
  components: {
    NewAppRelease,
    ReleasesOptions,
    CopyButton,
    ReleaseViewDialog
  },
  mixins: [failure, pagination],
  data() {
    return {
      loader: false,
      appReleases: [],
      headers: [
        { text: "Engine Version", value: "engine_version", sortable: false },
        { text: "pos", value: "pos_version", align: "center", sortable: false },
        { text: "kds", value: "kds_version", align: "center", sortable: false },
        { text: "kiosk", value: "kiosk_version", align: "center", sortable: false },
        { text: "Apps", value: "apps", align: "center", sortable: false },
        { text: "Created At", value: "created_at", align: "center", sortable: false },
        { text: "Tags", value: "tags", align: "center", sortable: false },
        { text: "Options", value: "options", align: "right", sortable: false }
      ],
      sortKey: "id",
      sortOrder: "DESC",
      searchKey: "version",
      page: 1,
      totalPage: 0,
      engine_version: "",
      stable: false,
      approved: false,
      deprecated: false,
      editRelease: {},
      archived: false,
      RVDialog:false,
      selectedRelease:{}
    };
  },
  created() {
    this.init();
  },
  methods: {
    newRelease() {
      this.$refs.newAppReleaseDialog.open();
    },
    openView(item) {
      this.selectedRelease = item;  
      this.RVDialog=true;
      this.$refs.releaseDialog.open(item);
    },
    open(item) {
      this.editRelease = item;
      this.$refs.newAppReleaseDialog.open();
    },
    getAppReleases() {
      this.loader = true;
      this.appReleases = [];

      let url = `${this.ADMIN_API_URL}/appReleases?page=${this.page - 1}&search_key=${this.searchKey}&sort_key=${this.sortKey}&limit=${this.limit}&status=${this.status}&sort_order=${this.sortOrder}`;
      if (this.engine_version) {
        url += `&engineVersion=${this.engine_version}`;
      }
      url += `&stable=${this.stable}`;

      url += `&approved=${this.approved}`;

      url += `&deprecated=${this.deprecated}`;

      url += `&archived=${this.archived}`;
      
      this.$http.get(url).then(
        function (res) {
          this.appReleases = res.body.data || [];
          this.totalPage = res.body.totalPage;
          this.page = res.body.pagination.page + 1;
          this.loader = false;
        },
        function (failure) {
          this.loader = false;
          this.handleFailure(failure);
        }
      );
    },
    search() {
      this.page = 1;
      this.getAppReleases();
    },
    onVersionChange(val) {
      this.engine_version = val;
      if (!val || val.length >= 4) {
        this.search();
      }
    },
    reload() {
      this.search();
    },
    init: function () {
      this.$store.commit("setTitle", "Digitory Apps");
      this.getAppReleases();
    },
    getAppUrl(engine_version) {
      return `${this.ADMIN_API_URL}/appReleases/getReleaseApps?version=${engine_version}`;
    },
    formatDate(date) {
    if (!date) return "—";
    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
    }
  }
};
</script>
